module.exports = __webpack_public_path__ + "media/images/add_box_light_blue-46beb14c9da823bdc55eb3cbbf9858bb.svg";